import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'


Vue.component('RecycleScroller', RecycleScroller)//注册为全局组件
// // 设置基础URL（可选）
// axios.defaults.baseURL = 'http://www.sqf.com/api' 
// // 挂载到Vue原型
// Vue.prototype.$axios = axios

Vue.config.productionTip = false
import locale from 'element-ui/lib/locale/lang/ko' // 引入韩语语言包
Vue.use(ElementUI, { locale }); // 设置 Element UI 为韩语界面
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
